import {_,Backbone,Obscura} from '../../vendor';

import InboomaBaseAsyncCollection from './InboomaBaseAsyncCollection';
import FacilitySlot from '../models/FacilitySlot';

const FacilitySlotsProxy = Obscura.extend({

  getByContingent : function(conId) {
    return this.where({'contingent_id' : conId});
  },

});

export default InboomaBaseAsyncCollection.extend({
  
  collectionName : 'facility_slots',
  model : FacilitySlot,
  url : '/facility_slots',
  proxy : FacilitySlotsProxy,

});